import { pushScopeId, popScopeId, openBlock, createBlock, withScopeId, createVNode, defineComponent, resolveComponent, Fragment, renderList, withModifiers, toDisplayString, createCommentVNode, Transition } from 'vue';

var script$2 = {
  name: 'IconArrow'
};

const _withId$2 = /*#__PURE__*/withScopeId("data-v-0539b091");

pushScopeId("data-v-0539b091");

const _hoisted_1$2 = {
  class: "icon-arrow",
  version: "1.1",
  x: "0px",
  y: "0px",
  viewBox: "0 0 492.004 492.004",
  style: {
    "enable-background": "new 0 0 492.004 492.004"
  },
  "xml:space": "preserve"
};

const _hoisted_2$2 = /*#__PURE__*/createVNode("g", null, [/*#__PURE__*/createVNode("g", null, [/*#__PURE__*/createVNode("path", {
  d: "M382.678,226.804L163.73,7.86C158.666,2.792,151.906,0,144.698,0s-13.968,2.792-19.032,7.86l-16.124,16.12    c-10.492,10.504-10.492,27.576,0,38.064L293.398,245.9l-184.06,184.06c-5.064,5.068-7.86,11.824-7.86,19.028    c0,7.212,2.796,13.968,7.86,19.04l16.124,16.116c5.068,5.068,11.824,7.86,19.032,7.86s13.968-2.792,19.032-7.86L382.678,265    c5.076-5.084,7.864-11.872,7.848-19.088C390.542,238.668,387.754,231.884,382.678,226.804z"
})])], -1);

const _hoisted_3$2 = /*#__PURE__*/createVNode("g", null, null, -1);

const _hoisted_4$2 = /*#__PURE__*/createVNode("g", null, null, -1);

const _hoisted_5$1 = /*#__PURE__*/createVNode("g", null, null, -1);

const _hoisted_6$1 = /*#__PURE__*/createVNode("g", null, null, -1);

const _hoisted_7$1 = /*#__PURE__*/createVNode("g", null, null, -1);

const _hoisted_8$1 = /*#__PURE__*/createVNode("g", null, null, -1);

const _hoisted_9$1 = /*#__PURE__*/createVNode("g", null, null, -1);

const _hoisted_10$1 = /*#__PURE__*/createVNode("g", null, null, -1);

const _hoisted_11$1 = /*#__PURE__*/createVNode("g", null, null, -1);

const _hoisted_12$1 = /*#__PURE__*/createVNode("g", null, null, -1);

const _hoisted_13$1 = /*#__PURE__*/createVNode("g", null, null, -1);

const _hoisted_14$1 = /*#__PURE__*/createVNode("g", null, null, -1);

const _hoisted_15$1 = /*#__PURE__*/createVNode("g", null, null, -1);

const _hoisted_16$1 = /*#__PURE__*/createVNode("g", null, null, -1);

const _hoisted_17$1 = /*#__PURE__*/createVNode("g", null, null, -1);

popScopeId();

const render$2 = /*#__PURE__*/_withId$2((_ctx, _cache, $props, $setup, $data, $options) => {
  return openBlock(), createBlock("svg", _hoisted_1$2, [_hoisted_2$2, _hoisted_3$2, _hoisted_4$2, _hoisted_5$1, _hoisted_6$1, _hoisted_7$1, _hoisted_8$1, _hoisted_9$1, _hoisted_10$1, _hoisted_11$1, _hoisted_12$1, _hoisted_13$1, _hoisted_14$1, _hoisted_15$1, _hoisted_16$1, _hoisted_17$1]);
});

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$2 = "\n.icon-arrow[data-v-0539b091] {\r\n        width: 16px;\r\n        height: 16px;\r\n        fill: #ffffff;\n}\r\n";
styleInject(css_248z$2);

script$2.render = render$2;
script$2.__scopeId = "data-v-0539b091";

var script$1 = {
  name: 'IconClose'
};

const _withId$1 = /*#__PURE__*/withScopeId("data-v-67945f76");

pushScopeId("data-v-67945f76");

const _hoisted_1$1 = {
  class: "close-icon",
  version: "1.1",
  id: "Layer_1",
  x: "0px",
  y: "0px",
  viewBox: "0 0 492 492",
  style: {
    "enable-background": "new 0 0 492 492"
  },
  "xml:space": "preserve"
};

const _hoisted_2$1 = /*#__PURE__*/createVNode("g", null, [/*#__PURE__*/createVNode("g", null, [/*#__PURE__*/createVNode("path", {
  d: "M300.188,246L484.14,62.04c5.06-5.064,7.852-11.82,7.86-19.024c0-7.208-2.792-13.972-7.86-19.028L468.02,7.872    c-5.068-5.076-11.824-7.856-19.036-7.856c-7.2,0-13.956,2.78-19.024,7.856L246.008,191.82L62.048,7.872    c-5.06-5.076-11.82-7.856-19.028-7.856c-7.2,0-13.96,2.78-19.02,7.856L7.872,23.988c-10.496,10.496-10.496,27.568,0,38.052    L191.828,246L7.872,429.952c-5.064,5.072-7.852,11.828-7.852,19.032c0,7.204,2.788,13.96,7.852,19.028l16.124,16.116    c5.06,5.072,11.824,7.856,19.02,7.856c7.208,0,13.968-2.784,19.028-7.856l183.96-183.952l183.952,183.952    c5.068,5.072,11.824,7.856,19.024,7.856h0.008c7.204,0,13.96-2.784,19.028-7.856l16.12-16.116    c5.06-5.064,7.852-11.824,7.852-19.028c0-7.204-2.792-13.96-7.852-19.028L300.188,246z"
})])], -1);

const _hoisted_3$1 = /*#__PURE__*/createVNode("g", null, null, -1);

const _hoisted_4$1 = /*#__PURE__*/createVNode("g", null, null, -1);

const _hoisted_5 = /*#__PURE__*/createVNode("g", null, null, -1);

const _hoisted_6 = /*#__PURE__*/createVNode("g", null, null, -1);

const _hoisted_7 = /*#__PURE__*/createVNode("g", null, null, -1);

const _hoisted_8 = /*#__PURE__*/createVNode("g", null, null, -1);

const _hoisted_9 = /*#__PURE__*/createVNode("g", null, null, -1);

const _hoisted_10 = /*#__PURE__*/createVNode("g", null, null, -1);

const _hoisted_11 = /*#__PURE__*/createVNode("g", null, null, -1);

const _hoisted_12 = /*#__PURE__*/createVNode("g", null, null, -1);

const _hoisted_13 = /*#__PURE__*/createVNode("g", null, null, -1);

const _hoisted_14 = /*#__PURE__*/createVNode("g", null, null, -1);

const _hoisted_15 = /*#__PURE__*/createVNode("g", null, null, -1);

const _hoisted_16 = /*#__PURE__*/createVNode("g", null, null, -1);

const _hoisted_17 = /*#__PURE__*/createVNode("g", null, null, -1);

popScopeId();

const render$1 = /*#__PURE__*/_withId$1((_ctx, _cache, $props, $setup, $data, $options) => {
  return openBlock(), createBlock("svg", _hoisted_1$1, [_hoisted_2$1, _hoisted_3$1, _hoisted_4$1, _hoisted_5, _hoisted_6, _hoisted_7, _hoisted_8, _hoisted_9, _hoisted_10, _hoisted_11, _hoisted_12, _hoisted_13, _hoisted_14, _hoisted_15, _hoisted_16, _hoisted_17]);
});

var css_248z$1 = "\n.close-icon[data-v-67945f76] {\r\n        width: 16px;\r\n        height: 16px;\r\n        cursor: pointer;\r\n        fill: #999;\n}\n.close-icon[data-v-67945f76]:hover {\r\n        fill: #fff;\n}\r\n";
styleInject(css_248z$1);

script$1.render = render$1;
script$1.__scopeId = "data-v-67945f76";

var script = defineComponent({
  name: 'GridImages',
  props: {
    items: {
      type: Array,
      default: () => {
        return [];
      }
    },
    css: {
      type: String,
      default: () => 'h-250 h-md-400 h-lg-600'
    },
    cells: {
      type: Number,
      default: () => 5
    }
  },
  components: {
    IconArrow: script$2,
    IconClose: script$1
  },

  data() {
    return {
      src: '',
      index: -1,
      loading: false,
      events: [],
      selectedItem: null
    };
  },

  methods: {
    bind() {
      if (this.events.length > 0) return;
      this.events.push(['keydown', e => {
        if (this.index < 0) return;

        if (e.keyCode === 37) {
          this.prev();
        } else if (e.keyCode === 39) {
          this.next();
        } else if (e.keyCode === 27) {
          this.close();
        }
      }]);
      this.events.forEach(e => {
        window.addEventListener(e[0], e[1]);
      });
    },

    show(i) {
      if (i >= this.items.length) {
        i = 0;
      }

      if (i < 0) {
        i = this.items.length - 1;
      }

      this.loading = true;
      this.bind();
      this.index = i;
      this.selectedItem = this.items[i];
      const src = this.items[i];
      const img = new Image();
      img.src = src;

      img.onload = () => {
        this.loading = false;
        this.src = src;
      };
    },

    next() {
      this.show(this.index - 1);
    },

    prev() {
      this.show(this.index + 1);
    },

    close() {
      this.index = -1;
      this.events.forEach(e => {
        window.removeEventListener(e[0], e[1]);
      });
      this.events = [];
    },

    bg(url) {
      const convertUrl = url;
      return convertUrl && convertUrl.length > 0 ? `background-image: url('${convertUrl}')` : '';
    }

  }
});

const _withId = /*#__PURE__*/withScopeId("data-v-51f575e2");

pushScopeId("data-v-51f575e2");

const _hoisted_1 = {
  key: 0,
  class: "gi-container"
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  key: 0,
  class: "gi-more"
};
const _hoisted_4 = {
  key: 0,
  class: "gi-modal"
};

popScopeId();

const render = /*#__PURE__*/_withId((_ctx, _cache, $props, $setup, $data, $options) => {
  const _component_IconClose = resolveComponent("IconClose");

  const _component_IconArrow = resolveComponent("IconArrow");

  return _ctx.items.length > 0 ? (openBlock(), createBlock("div", _hoisted_1, [createVNode("div", {
    class: ["gi-grid", [_ctx.css, _ctx.items.length > _ctx.cells ? 'gi-grid-' + _ctx.cells : 'gi-grid-' + _ctx.items.length]]
  }, [(openBlock(true), createBlock(Fragment, null, renderList(_ctx.items, (media, i) => {
    return openBlock(), createBlock("a", {
      key: i,
      class: "gi-item",
      href: _ctx.items[i].url,
      role: "link",
      onClick: withModifiers($event => _ctx.show(i, media), ["prevent"]),
      style: _ctx.bg(media)
    }, [i < _ctx.cells ? (openBlock(), createBlock("span", _hoisted_2, [i === _ctx.cells - 1 && _ctx.items.length - _ctx.cells > 0 ? (openBlock(), createBlock("span", _hoisted_3, toDisplayString(_ctx.items.length - _ctx.cells) + "+ ", 1)) : createCommentVNode("", true)])) : createCommentVNode("", true)], 12, ["href", "onClick"]);
  }), 128))], 2), createVNode(Transition, {
    name: "fade"
  }, {
    default: _withId(() => [_ctx.index >= 0 ? (openBlock(), createBlock("div", _hoisted_4, [createVNode("div", {
      class: "gi-modal-close",
      onClick: _cache[1] || (_cache[1] = (...args) => _ctx.close && _ctx.close(...args))
    }, [createVNode(_component_IconClose)]), createVNode("button", {
      class: "gi-modal-prev gi-btn",
      onClick: _cache[2] || (_cache[2] = (...args) => _ctx.prev && _ctx.prev(...args))
    }, [createVNode(_component_IconArrow, {
      style: {
        "transform": "rotate(180deg)"
      }
    })]), createVNode("button", {
      class: "gi-modal-next gi-btn",
      onClick: _cache[3] || (_cache[3] = (...args) => _ctx.next && _ctx.next(...args))
    }, [createVNode(_component_IconArrow)]), createVNode("div", {
      class: "gi-modal-img",
      onClick: _cache[4] || (_cache[4] = (...args) => _ctx.close && _ctx.close(...args))
    }, [createVNode("img", {
      src: _ctx.src,
      alt: ""
    }, null, 8, ["src"])])])) : createCommentVNode("", true)]),
    _: 1
  })])) : createCommentVNode("", true);
});

var css_248z = "\n.fade-enter-active[data-v-51f575e2],\n    .fade-leave-active[data-v-51f575e2] {\n        transition: opacity 1s ease;\n}\n.fade-enter-from[data-v-51f575e2],\n    .fade-leave-to[data-v-51f575e2] {\n        opacity: 0;\n}\n.gi-container[data-v-51f575e2] {\n        width: 100%;\n        height: 100%;\n}\n.gi-grid[data-v-51f575e2] {\n        position: relative;\n        display: block;\n        cursor: pointer;\n        background: #000000;\n        height: 100%;\n}\n.border-gi-grid .gi-grid[data-v-51f575e2] {\n        border-radius: 0 0 6px 6px;\n}\n.gi-item[data-v-51f575e2] {\n        position: absolute;\n        background-position: center center;\n        background-repeat: no-repeat;\n        background-size: cover;\n        border-top: solid 2px #fff;\n        border-right: solid 2px #fff;\n        overflow: hidden;\n}\n.gi-item[data-v-51f575e2]:hover, .gi-item[data-v-51f575e2]:focus {\n    //opacity: 0.6;\n}\n.disable-hover[data-v-51f575e2] {\n.gi-item[data-v-51f575e2]:hover {\n            opacity: 1;\n}\n.gi-item[data-v-51f575e2]:focus {\n            opacity: 1;\n}\n}\n.gi-grid-1 .gi-item[data-v-51f575e2] {\n        width: 100%;\n        height: 100%;\n}\n.gi-grid-2 .gi-item[data-v-51f575e2], .gi-grid-3 .gi-item[data-v-51f575e2], .gi-grid-4 .gi-item[data-v-51f575e2], .gi-grid-5 .gi-item[data-v-51f575e2] {\n        width: 50%;\n}\n.gi-grid-2 .gi-item[data-v-51f575e2], .gi-grid-3 .gi-item[data-v-51f575e2]:nth-child(1), .gi-grid-4 .gi-item[data-v-51f575e2]:nth-child(1) {\n        height: 100%;\n}\n.gi-grid-3 .gi-item[data-v-51f575e2]:nth-child(2), .gi-grid-3 .gi-item[data-v-51f575e2]:nth-child(3), .gi-grid-5 .gi-item[data-v-51f575e2]:nth-child(1), .gi-grid-5 .gi-item[data-v-51f575e2]:nth-child(2) {\n        height: 50%;\n}\n.gi-item[data-v-51f575e2]:last-child, .gi-grid-2 .gi-item[data-v-51f575e2]:nth-child(2), .gi-grid-3 .gi-item[data-v-51f575e2]:nth-child(2), .gi-grid-3 .gi-item[data-v-51f575e2]:nth-child(3), .gi-grid-4 .gi-item[data-v-51f575e2]:nth-child(2), .gi-grid-4 .gi-item[data-v-51f575e2]:nth-child(3), .gi-grid-4 .gi-item[data-v-51f575e2]:nth-child(4), .gi-grid-5 .gi-item[data-v-51f575e2]:nth-child(3), .gi-grid-5 .gi-item[data-v-51f575e2]:nth-child(4), .gi-grid-5 .gi-item[data-v-51f575e2]:nth-child(5) {\n        left: auto;\n        right: 0;\n        border-right: 0;\n}\n.gi-grid-3 .gi-item[data-v-51f575e2]:nth-child(3), .gi-grid-4 .gi-item[data-v-51f575e2]:nth-child(4), .gi-grid-5 .gi-item[data-v-51f575e2]:nth-child(2), .gi-grid-5 .gi-item[data-v-51f575e2]:nth-child(5) {\n        bottom: 0;\n        top: auto;\n}\n.gi-grid-4 .gi-item[data-v-51f575e2]:nth-child(3), .gi-grid-5 .gi-item[data-v-51f575e2]:nth-child(4) {\n        top: 33.333333333333336%;\n}\n.gi-grid-4 .gi-item[data-v-51f575e2]:nth-child(2), .gi-grid-4 .gi-item[data-v-51f575e2]:nth-child(3), .gi-grid-4 .gi-item[data-v-51f575e2]:nth-child(4), .gi-grid-5 .gi-item[data-v-51f575e2]:nth-child(3), .gi-grid-5 .gi-item[data-v-51f575e2]:nth-child(4), .gi-grid-5 .gi-item[data-v-51f575e2]:nth-child(5) {\n        height: 33.333333333333336%;\n}\n.gi-more[data-v-51f575e2] {\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        text-align: center;\n        color: #fff;\n        font-size: 3rem;\n        background-color: rgba(0, 0, 0, .4);\n}\n.gi-more[data-v-51f575e2]:before {\n        display: inline-block;\n        content: \"\";\n        vertical-align: middle;\n        height: 100%;\n}\n.gi-modal[data-v-51f575e2] {\n        transition: opacity .2s ease;\n        position: fixed;\n        z-index: 99999;\n        top: 0;\n        left: 0;\n        bottom: 0;\n        right: 0;\n        width: 100%;\n        min-height: 100%;\n        height: 100vh;\n        background-color: rgba(0, 0, 0, .8);\n        display: block;\n        -webkit-user-select: none;\n        -khtml-user-select: none;\n        -o-user-select: none;\n        user-select: none;\n}\n.gi-modal-close[data-v-51f575e2] {\n        position: absolute;\n        right: 20px;\n        top: 20px;\n        color: #fff;\n}\n.gi-modal-next[data-v-51f575e2], .gi-modal-prev[data-v-51f575e2] {\n        position: absolute;\n        top: 50%;\n        left: 20px;\n        margin-top: -25px;\n        z-index: 999;\n        cursor: pointer;\n        color: #fff;\n        background-color: transparent;\n        border: none;\n}\n.gi-modal-next[data-v-51f575e2] {\n        left: auto;\n        right: 20px;\n}\n.gi-modal-img[data-v-51f575e2] {\n        position: absolute;\n        top: 10px;\n        left: 70px;\n        right: 70px;\n        bottom: 10px;\n        text-align: center;\n}\n.gi-modal-img[data-v-51f575e2]:before {\n        display: inline-block;\n        content: \"\";\n        vertical-align: middle;\n        height: 100%;\n}\n.gi-modal-img img[data-v-51f575e2] {\n        max-width: 100%;\n        max-height: 100%;\n        vertical-align: middle;\n        object-fit: contain;\n}\n.gi-modal-img video[data-v-51f575e2] {\n        max-width: 100%;\n        max-height: 100%;\n        vertical-align: middle;\n        object-fit: contain;\n}\n.gi-modal-img .spinner[data-v-51f575e2] {\n        width: 150px;\n        position: absolute;\n        margin-left: -75px;\n        top: 50%;\n        left: 50%;\n        z-index: 1;\n}\n.gi-btn[data-v-51f575e2] {\n        padding: 9px 6px;\n        transition: .25s;\n        border-radius: 4px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n}\n.gi-btn[data-v-51f575e2]:hover {\n        background: #5A8DEE;\n}\n";
styleInject(css_248z);

script.render = render;
script.__scopeId = "data-v-51f575e2";

// Import vue component
// IIFE injects install function into component, allowing component
// to be registered via Vue.use() as well as Vue.component(),

var entry_esm = /*#__PURE__*/(() => {
  // Get component instance
  const installable = script; // Attach install function executed by Vue.use()

  installable.install = app => {
    app.component('GridImages', installable);
  };

  return installable;
})(); // It's possible to expose named exports when writing components that can
// also be used as directives, etc. - eg. import { RollupDemoDirective } from 'rollup-demo';
// export const RollupDemoDirective = directive;

export default entry_esm;
